import { ReactElement } from 'react';
import { ASSORTMENT_FILTERS, FACET_FILTERS } from '@client/catalog/utils/facets';
import { useTranslate } from '@client/i18n/hooks';
import { CHECKBOX_TOGGLE_STYLE, CheckboxToggle } from 'b2b-components/core/components/Form/Checkbox/CheckboxToggle';
import { Props } from './CoreAssortmentToggleFilter.types';
import './CoreAssortmentToggleFilter.scss';

export const CoreAssortmentToggleFilter = ({
  isChecked,
  onFacetFilterCheckboxChange,
}: Props): ReactElement => {
  const t = useTranslate();

  const handleChange = () => {
    onFacetFilterCheckboxChange(FACET_FILTERS.customerAssortment, ASSORTMENT_FILTERS.coreAssortment);
  };

  return (
    <div className='CoreAssortmentToggleFilter'>
      <CheckboxToggle
        onChange={handleChange}
        isChecked={isChecked}
        style={isChecked ? CHECKBOX_TOGGLE_STYLE.SUCCESS : CHECKBOX_TOGGLE_STYLE.DEFAULT}
        tooltipContent={t('Activate this filter to only see items from your core assortment')}
      />
      <span className='CoreAssortmentToggleFilter-Label'>
      {t('Core assortment only')}
      </span>
    </div>
  );
};
